import { PUT_STATES_LIST } from "../../constants/action-constants";

//Using hardcoded data as api is not available yet.
const initialState = {
  list: [],
};

const statesListReducer = (state = initialState, action) => {
  switch (action.type) {
    case PUT_STATES_LIST:
      return { list: action.payload };
    default:
      return state;
  }
};

export default statesListReducer;
